module.exports = __webpack_public_path__ + "img/widget-img.00e7fd68.png";